import { frontendURL } from '../../../helper/URLHelper';
import ChatbotAIDashboard from './pages/ChatbotAIDashboard.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/chatbot-ai'),
      name: 'chatbot_ai_index',
      meta: { permissions: ['administrator'] },
      component: ChatbotAIDashboard,
    },
  ],
};
